import i18n from '../i18n'

export function getMessage (field) {
  if (field.$params.maxLength && !field.maxLength) {
    return i18n.tc(
      'recipients.create.input-error-maxlength',
      field.$params.maxLength.max,
      { length: field.$params.maxLength.max }
    )
  }

  if (field.$params.minLength && !field.minLength) {
    return i18n.tc(
      'recipients.create.input-error-minlength',
      field.$params.minLength.min,
      { length: field.$params.minLength.min }
    )
  }

  if (field.$params.required && !field.required) {
    return i18n.t('recipients.create.input-error-required')
  }

  if (field.$invalid) {
    return i18n.t('recipients.create.input-error')
  }
}

export function feedbacks (field, condition = true) {
  return [
    {
      condition: condition && field.$invalid && field.$dirty,
      msg: getMessage(field)
    }
  ]
}

export function getState (field, condition = true) {
  return condition && field.$invalid && field.$dirty ? 'error' : ''
}
